import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchWrapper } from '_helpers';

const name = 'contextDetails';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports
export const contextActions = { ...slice.actions, ...extraActions };
export const contextReducer = slice.reducer;

// implementation
function createInitialState() {
    return {
        data: null,
        isLoading: false,
        error: null,
    };
}

function createExtraActions() {
    const baseUrl = process.env.REACT_APP_API_URL;

    return {
        getContextDetail: getContextDetail(),
    };

    function getContextDetail() {
        return createAsyncThunk(
            `${name}/getContextDetail`,
            async () => await fetchWrapper.get(`${baseUrl}/context_details`)
        );
    }
}

function createExtraReducers() {
    return (builder) => {
        getContextDetail();

        function getContextDetail() {
            var { pending, fulfilled, rejected } = extraActions.getContextDetail;
            builder
                .addCase(pending, (state) => {
                    state.isLoading = true;
                })
                .addCase(fulfilled, (state, action) => {
                    state.isLoading = false;
                    state.data = action.payload;
                })
                .addCase(rejected, (state, action) => {
                    state.isLoading = false;
                    state.error = action.error.message || 'Echec de récupération des pré-alertes';
                });
        }
    };
}

export default contextReducer;

